module.exports = __webpack_public_path__ + "img/audi_scroll_view.c1bbeb23.jpg";